import { useMemo } from "react";
import "../../styles/analysis.css";

import { hasRemediationAccess } from "../../config/searchSpaces";
import Sidebar from "../layout/Sidebar";
import PageFeedback from "../layout/PageFeedback";

import AllTypesPieCard from "./charts/AllTypesPieCard";
import AnalysisSummaryCard from "./cards/AnalysisSummaryCard";
import RemediationDiagramCard from "./charts/RemediationDiagramCard";
import { useAnalysisPageData } from "./useAnalysisPageData";

function Analysis({ searchSpace }) {
  const {
    loading,
    status,
    error,
    analysisData = {},
  } = useAnalysisPageData(searchSpace);

  const pieData = useMemo(() => {
    return (analysisData?.TYPES || []).map((t) => ({
      name: t.TYPE_NAME,
      value: Number(t.AMOUNT || 0),
    }));
  }, [analysisData?.TYPES]);

  const isInSpace = searchSpace === "in";

  return (
    <div className="analysis-shell">
      <div className="analysis-main">
        <div className="analysis-inner">
          <div className="analysis-header-row">
            <h2 className="analysis-title">Analysis</h2>
          </div>

          {hasRemediationAccess(searchSpace) ? (
            <div className="analysis-files-section-wide analysis-section">
              {!isInSpace ? (
                <div className="analysis-files-empty">
                  Analysis data is currently only implemented for the IN search space.
                </div>
              ) : (
                <>
                  {status && !error && (
                    <PageFeedback type="info">{status}</PageFeedback>
                  )}

                  {loading ? (
                    <PageFeedback type="info">
                      Loading analysis data...
                    </PageFeedback>
                  ) : error ? (
                    <PageFeedback type="error">{error}</PageFeedback>
                  ) : analysisData?.AINSTEIN_STATUS === "offline" ? (
                    <PageFeedback type="error">Service offline</PageFeedback>
                  ) : (
                    <>
                      <div className="analysis-top-stack">
                        <AllTypesPieCard title="Remediation Types" data={pieData} />
                      </div>

                      <div className="analysis-summary-row">
                        <AnalysisSummaryCard stats={analysisData} />
                      </div>

                      <div className="analysis-charts-grid">
                        {(analysisData?.TYPES || []).map((t) => (
                          <RemediationDiagramCard
                            key={t.TYPE_NAME}
                            searchSpace={searchSpace}
                            remediationType={t.TYPE_NAME}
                          />
                        ))}
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          ) : (
            <div className="analysis-files-section-wide">
              <div className="analysis-files-empty">
                Remediation data is not available for this space.
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Analysis;